// extracted by mini-css-extract-plugin
module.exports = {"sub-title":"ResetPassword_sub-title__1dtzP","errorMessage":"ResetPassword_errorMessage__2__13","return-login":"ResetPassword_return-login__3fUC0"};